import React from 'react';
import './index.css';
import { wordsArr } from './words';
import stone1 from './images/obs/_rocks/stone01.png'; //https://raventale.itch.io/additional-elements-for-nature-tile-set
import stone6 from './images/obs/_rocks/stone06.png';


export default class Obstacle extends React.Component {

  constructor(props) {
    super(props);
    this.obstacle = React.createRef();
    this.state = { 
      text:'',
      lasRender:0,
      move: 0,
      speed: 4.5,
      playing:false,
      obsImg: stone1
    };
    this.loop = this.loop.bind(this)
    this.update = this.update.bind(this)
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
  }

  getRandomFromArray(arr){
    let index = this.getRandomInt(0, arr.length);
    return arr[index]
  }

  getRando() {
    //1,2,3
    let text;
    if (this.props.difficulty === 1) {
      const homeRow = [65,83,68,70,71,72,74,75,76] //186 semi colon
      text = String.fromCharCode(this.getRandomFromArray(homeRow));
    } else if (this.props.difficulty === 2) {
      text = String.fromCharCode(this.getRandomInt(65,91));
    } else if (this.props.difficulty === 3){
      let index = this.getRandomInt(0, wordsArr.length)
      text = wordsArr[index].toUpperCase()
    }
    
    if (text === this.state.text) {
      this.getRando()
    } else {
      this.props.getText(text);

      this.setState({text: text});
      //97-122 a-z??
      //65-91 -capitals???      
    }
    this.props.getSpeed(this.state.speed)
  }


  
  loop = (timestamp) => {
    let progress = timestamp - this.state.lastRender
    this.update(progress)  
    this.setState({lastRender : timestamp})
    this.props.playing && window.requestAnimationFrame(this.loop)
  }

  update = (progress) => {
    let obstacle = document.getElementById('obstacle')
    // Update the state of the world for the elapsed time since last render
    //move += progress / speed;
    let handleMove = () => {
      if (this.state.move > 990) {
        let img = Math.random() > .5 ? stone1 : stone6

        this.setState({move:0, obsImg:img});
        this.getRando()

        obstacle.style.left = "850px";

        if (this.state.speed > 4) { //1.9 about my top speed...
          this.setState({speed : this.state.speed - .14});
        } else if (this.state.speed >= 3 && this.state.speed < 4) { 
          this.setState({speed : this.state.speed - .1});
        } else if (this.state.speed >= 2.3 && this.state.speed < 3) { 
          this.setState({speed : this.state.speed - .03});
        } else if (this.state.speed >= 1.81 && this.state.speed < 2.3) { 
          this.setState({speed : this.state.speed - .01});
        } else if (this.state.speed >= 1.2 && this.state.speed < 1.81 && this.props.difficulty !== 3) { 
          this.setState({speed : this.state.speed - .01});
        } else if (this.state.speed >= .8 && this.state.speed < 1.81 && this.props.difficulty !== 3) { 
          this.setState({speed : this.state.speed - .005});
        }


      }
      //hitbox cords (ends game if Y < 50)
      if (this.state.move > 815 && this.state.move < 915) { //800 & 925 are actual fit
        let left = 850 - this.state.move;
        //console.log(left)
        this.props.getObstacleX(left);     
      }

      obstacle.style.transform = 'translate3d(-'+this.state.move+'px, 0px, 0px)'; //3d uses hardware accel to help cpu: https://stackoverflow.com/questions/13176746/css-keyframe-animation-cpu-usage-is-high-should-it-be-this-way
      //obstacle.style.transform = 'translateX(-' + move + 'px)'; //move is the sum from original x position     
    }

    let newMove = this.state.move + (progress || 0) / this.state.speed;
    this.setState({move: newMove},handleMove)
  }


  componentDidMount(){
    const obstacle = document.getElementById('obstacle');
    obstacle.style.left = "850px";   
    this.getRando()
    //window.requestAnimationFrame(this.loop)       
  }

  componentDidUpdate(prevProps) {
    if (prevProps.jumpCount === 0 && this.props.jumpCount === 1) {
      this.getRando()
      setTimeout(()=>{window.requestAnimationFrame(this.loop)},2000)
    }
  }

  componentWillUnmount() {
    window.cancelAnimationFrame(this.loop)
  }


//      <div id="obstacle" tabIndex="0" ref={this.obstacle} />
  render() {
    return (

      <img id="obstacle" tabIndex="0" ref={this.obstacle} src={this.state.obsImg} alt="rock obstacle" />      
    );
  }
}
